export const APP_VERSION = '8fd654cbc497f7d21eab60adcecedd76edf2fb31'; //
